import { Injectable, Query } from '@nestjs/common';
import {   SizeMatrixActivateDeactivateDto, SizeMatrixFabricCodeDto, SizeMatrixResponseModel } from '@project-management-system/shared-models';
import { DataSource, Not } from 'typeorm';
import { ErrorResponse } from 'packages/libs/backend-utils/src/models/global-res-object';
import { SizeMatrixRepository } from './size-matrix.repo';
import { SizeMatrixAdapter } from './adapter/size-matrix-adapter';
import { SIzeMatrixFabricBDto } from './dto/size-matrix-dto';
import { SizehtMatrixEntity } from '../po-bom/entittes/size-ht-matrix-entity';

@Injectable()
export class SizeMatrixService {
    constructor(
        private repo: SizeMatrixRepository,
        private  adaptor: SizeMatrixAdapter,

    ) { }
  

    //   async createSizeMatrix(req: SIzeMatrixFabricBDto, isUpdate: boolean): Promise<SizeMatrixResponseModel> {
    //     try {
    //         let findAllRecords: SizehtMatrixEntity[];
    //             // console.log(req,"req======================")
    //         if (!isUpdate) {
    //             findAllRecords = await this.repo.find();
    //         } else {
    //             findAllRecords = await this.repo.find({ where: { id: Not(req.id) } });
    //         }
    //         const adapterData = this.adaptor.convertDtoToEntity(req);
    //         let styleString = '';
    //         let fabricCombinationsString = '';
            
    //         if (Array.isArray(adapterData.style) && adapterData.style.length > 0) {
    //             styleString = adapterData.style.join(', ');
    //         }
            
    //         if (Array.isArray(adapterData.fabricCombinations) && adapterData.fabricCombinations.length > 0) {
    //             fabricCombinationsString = adapterData.fabricCombinations.join(', ');
    //         }
    //         if (isUpdate) {
    //             adapterData.id = req.id;
    //             adapterData.updatedUser = req.createdUser;
    //             adapterData.style = styleString;
    //             adapterData.fabricCombinations = fabricCombinationsString;

    //         } else {
    //             adapterData.createdUser = req.createdUser;
    //             adapterData.style = styleString;
    //             adapterData.fabricCombinations = fabricCombinationsString;

    //         }
    
    //         await this.repo.save(adapterData);
    
    //         return new SizeMatrixResponseModel(true, 200, isUpdate ? 'Updated Successfully' : 'Created Successfully');
    //     } catch (err) {
    //         throw err;
    //     }
    // }
    async createSizeMatrix(req: SIzeMatrixFabricBDto, isUpdate: boolean): Promise<SizeMatrixResponseModel> {
        try {
            let findAllRecords: SizehtMatrixEntity[];
            if (!isUpdate) {
                findAllRecords = await this.repo.find();
            } else {
                findAllRecords = await this.repo.find({ where: { id: Not(req.id) } });
            }
            
            const adapterData = this.adaptor.convertDtoToEntity(req);
    
            // Retain existing style and fabric combinations if not included in the request
            const existingRecord = await this.repo.findOne({ where: { id: Not(req.id) } });
            if (existingRecord) {
                adapterData.style = adapterData.style || existingRecord.style;
                adapterData.fabricCombinations = adapterData.fabricCombinations || existingRecord.fabricCombinations;
            }
    
            // Convert arrays to strings
            adapterData.style = Array.isArray(adapterData.style) ? adapterData.style.join(', ') : adapterData.style;
            adapterData.fabricCombinations = Array.isArray(adapterData.fabricCombinations) ? adapterData.fabricCombinations.join(', ') : adapterData.fabricCombinations;
    
            // Assign updated user for an update operation
            if (isUpdate) {
                adapterData.updatedUser = req.createdUser;
            } else {
                adapterData.createdUser = req.createdUser;
            }
    
            await this.repo.save(adapterData);
    
            return new SizeMatrixResponseModel(true, 200, isUpdate ? 'Updated Successfully' : 'Created Successfully');
        } catch (err) {
            throw err;
        }
    }
    
    // async getData(): Promise<SizeMatrixResponseModel> {
    //     const data = await this.repo.find()
    //     const Data: SizeMatrixFabricCodeDto[] = []
    //     for (const record of data) {
    //         const adapterData = this.adaptor.convertEntityToDto(record)
    //         Data.push(adapterData)
    //     }
    //     return new SizeMatrixResponseModel(true, 1111, 'Data retreived', Data)
    // }

  


    async activateOrDeactivate(Req: SizeMatrixActivateDeactivateDto): Promise<SizeMatrixResponseModel> {
        try {
            const StyleExists = await this.getSizeMatrixFabricById(Req.id);
            if (StyleExists) {
                if (Req.versionFlag !== StyleExists.versionFlag) {
                    throw new SizeMatrixResponseModel(false,10113, 'Someone updated the current Size Matrix information.Refresh and try again');
                } else {

                    const locationStatus = await this.repo.update(
                        { id: Req.id },
                        { isActive: Req.isActive, updatedUser: Req.updatedUser });

                    if (StyleExists.isActive) {
                        if (locationStatus.affected) {
                            const LocationResponse: SizeMatrixResponseModel = new SizeMatrixResponseModel(true, 10115, 'Matrix is Deactivated successfully');
                            return LocationResponse;
                        } else {
                            throw new SizeMatrixResponseModel(false,10111, 'Matrix is already deactivated');
                        }
                    } else {
                        if (locationStatus.affected) {
                            const LocationResponse: SizeMatrixResponseModel = new SizeMatrixResponseModel(true, 10114, 'Matrix is activated successfully');
                            return LocationResponse;
                        } else {
                            throw new SizeMatrixResponseModel(false,10112, 'Matrix is already activated');
                        }
                    }
                }
            } else {
                throw new SizeMatrixResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }
    async getSizeMatrixFabricById(id: number): Promise<SizehtMatrixEntity> {
        const Response = await this.repo.findOne({
            where: { id: id },
        });
        if (Response) {
            return Response;
        } else {
            return null;
        }
    }

}
